export default "/_assets/info.d188d2dc.svg"